var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "transparent",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 50 50;90 50 50",
    keyTimes: "0;1",
    dur: "0.24154589371980678s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30,
    stroke: "#4191ff",
    fill: "none",
    strokeDasharray: "23.561944901923447 188.49555921538757",
    strokeLinecap: "round",
    strokeWidth: 10,
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#4191ff;#4191ff",
    keyTimes: "0;1",
    dur: "0.24154589371980678s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30,
    stroke: "#4191ff",
    fill: "none",
    strokeDasharray: "23.561944901923447 188.49555921538757",
    strokeLinecap: "round",
    strokeWidth: 10,
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#4191ff;#4191ff",
    keyTimes: "0;1",
    dur: "0.24154589371980678s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30,
    stroke: "#4191ff",
    fill: "none",
    strokeDasharray: "23.561944901923447 188.49555921538757",
    strokeLinecap: "round",
    strokeWidth: 10,
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#4191ff;#4191ff",
    keyTimes: "0;1",
    dur: "0.24154589371980678s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30,
    stroke: "#4191ff",
    fill: "none",
    strokeDasharray: "23.561944901923447 188.49555921538757",
    strokeLinecap: "round",
    strokeWidth: 10,
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke",
    values: "#4191ff;#4191ff",
    keyTimes: "0;1",
    dur: "0.24154589371980678s",
    repeatCount: "indefinite"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.14931547.svg";
export { ForwardRef as ReactComponent };